const url = (path = "/") => {
    if(process.env.NODE_ENV === 'production') return `${window.location.origin}${path}`
    else return `http://localhost:8000${path}`
}
export default url